import { eventEmiter, rxPageSaved } from '../rxState';
import { API_PAGES } from '../../Constants';

import { api, getToken } from '../../utils/api';

export const save = (state, payload) => {

  let currentPage = state.currentPage;
  if (!currentPage || currentPage === '') {
    currentPage = 'optin';
  }

  const data = {
    action: 'save',
    username: state.userName,
    id: state.pageId,
    data: state.blocks,
    pageName: currentPage,
    token: getToken(),
    image: payload.image,
    exitpopupdata: state.exitModalData,
    exitpopupenabled: state.exitModalEnabled,
  };
  api(API_PAGES, 'POST', data)
    .then((res) => {
      eventEmiter.next({
        type: 'add-alert',
        payload: {
          type: 'success',
          text: 'Save successfully',
        },
      });
    })
    .catch((error) => {
      eventEmiter.next({
        type: 'add-alert',
        payload: {
          type: 'error',
          text: 'Error during Save',
          description: error.message,
        },
      });
    })
    .finally(() => {
      rxPageSaved.next(true);
    });
};
